import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { colors } from '../config/color';
import Typography from './Typography';

interface Props {
  current: 1 | 2 | 3;
}

const PurchaseSteps = ({ current }: Props) => {
  const classes = useStyles();

  const { t } = useTranslation('common');

  const getStepClassnames = (step: number) => {
    return classnames(classes.stepBubble, step > current && classes.stepBubbleInactive);
  };

  return (
    <div className={classes.container}>
      <div className={classes.stepContainer}>
        <div className={getStepClassnames(1)}>
          <div>1</div>
          <Typography color={colors.darkText} fontSize={16} fontWeight={400}>
            {t('purchase.step1')}
          </Typography>
        </div>
        <div className={getStepClassnames(2)}>
          <div>2</div>
          <Typography color={colors.darkText} fontSize={16} fontWeight={400}>
            {t('purchase.step2')}
          </Typography>
        </div>
        <div className={getStepClassnames(3)}>
          <div>3</div>
          <Typography color={colors.darkText} fontSize={16} fontWeight={400}>
            {t('purchase.step3')}
          </Typography>
        </div>
        <div className={classes.stepBubbleLine} />
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 45,
  },
  stepContainer: {
    width: '100%',
    maxWidth: 380,
    display: 'flex',
    justifyContent: 'space-between',
    justifyItems: 'center',
    alignItems: 'center',
    position: 'relative',
    marginBottom: 60,
  },
  stepBubbleLine: {
    height: 3,
    top: '50%',
    left: 0,
    right: 0,
    position: 'absolute',
    backgroundColor: colors.primary,
    zIndex: -1,
  },
  stepBubble: {
    height: 60,
    width: 60,
    fontSize: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    backgroundColor: colors.primary,
    color: colors.white,
    '& > p': {
      position: 'absolute',
      top: 60,
    },
  },
  stepBubbleInactive: {
    color: colors.primary,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: colors.primary,
    backgroundColor: colors.white,
  },
});

export default PurchaseSteps;
